import { useMemo } from 'react';
import { SmartAction } from '@connect-x-app/shared-domain-models';

import { useSmartActions } from '../queries';

const sortByName = (smartActions: SmartAction[]) => [...smartActions].sort((a, b) => a.name.localeCompare(b.name));

export const useSmartActionGroups = () => {
  const { data: smartActions = [], isLoading, refetch } = useSmartActions();

  const { customSmartActions, systemSmartActions } = useMemo(
    () => ({
      customSmartActions: sortByName(smartActions.filter(smartAction => !smartAction.isDefault)),
      systemSmartActions: sortByName(smartActions.filter(smartAction => smartAction.isDefault)),
    }),
    [smartActions],
  );

  return { customSmartActions, isLoading, refetch, systemSmartActions };
};
